import React, { useEffect, useState } from "react";
import AnalyticsHeader from "../../header/AnalyticsHeader";
import InvestigatorContainer from "../../../../components/contsiners/InvestigatorContainer";
import CAMHeader from "../../../../components/Header/CAMHeader";
import CAMDrawer from "../../../../components/LeftSideBar/CAMDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  Snackbar,
  Alert,
  Divider,
  IconButton,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import DropdownsBar from "../../header/ProductSiteUnitSelector";
import TabsBar from "../../header/TabsNav";
import BreadcrumbsBar from "../../header/BreadcrumbNav";
import Pagination from "../../../../components/Pagination";
import ParameterTable from "./VisualizationsListTable";
import AddIcon from "@mui/icons-material/Add";
import "./index.scss";
import { plotTypeOptions } from "../constants";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchFolders,
  fetchSavedVizList,
} from "../../../../redux/visualization/actions";
import DatePicker from "react-datepicker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Label from "../../../../components/Label/Label";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Loader from "../../../../components/Loader/loader";

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { chartType } = useParams();

  const selectedChart =
    plotTypeOptions.find((opt) => opt.value === chartType)?.label ||
    "New Chart";

  // const {
  //   product = { id: "", name: "" },
  //   site = { id: "", name: "" },
  //   unitOfOperation = { id: "", name: "" },
  // } = useSelector((state) => state.shared.productSitesUopValues || {});

  const [anchorEl, setAnchorEl] = useState(null);
  const openChartMenu = Boolean(anchorEl);

  const reposrtsList = useSelector((state) => state.viz?.savedVizList || {});
  const { loader, apiError, message, data } = reposrtsList || {};

  const [page, setPage] = useState(1);
  const [activeFolder, setActiveFolder] = useState(null);

  // 🔹 Filters
  const [vizName, setVizName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  // 🔹 Snackbar states
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "info",
    text: "",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const formatDatesLocal = (value) => {
    if (!value) return value; // keep null/empty as-is
    const date = new Date(value);
    if (isNaN(date)) return value; // not a valid date, return as-is

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  // 🔹 Fetch function (used for both initial + filters)
  const fetchData = (flag) => {
    dispatch(
      fetchSavedVizList({
        // drug_product_id: product.id,
        // site_id: site.id,
        // unit_op_id: unitOfOperation.id,
        page_number: page,
        user_id: localStorage.getItem("userid"),
        viz_name: vizName,
        start_date: startDate ? formatDatesLocal(startDate) : undefined,
        end_date: endDate ? formatDatesLocal(endDate) : undefined,
        withFilters: flag,
        status: statusFilter,
      }),
    );
  };

  // 🔹 Handle API notifications
  useEffect(() => {
    if (apiError) {
      setSnackbar({
        open: true,
        severity: "error",
        text: message || "Something went wrong",
      });
    } else if (message) {
      setSnackbar({
        open: true,
        severity: "success",
        text: message,
      });
    }
  }, [apiError, message]);

  // 🔹 Fetch on page load + pagination
  // useEffect(() => {
  //   // fetchData(false);
  //   setVizName("");
  //   setStartDate(null);
  //   setEndDate(null);
  //   setPage(1);
  // }, [
  //   dispatch,
  //   page,
  //   // product.id, site.id, unitOfOperation.id
  // ]);

  useEffect(() => {
    setVizName("");
    setStartDate(null);
    setEndDate(null);
    setPage(1);
  }, []);

  useEffect(
    () => {
      // if (product.id && site.id && unitOfOperation.id) {
      fetchData(false);
      // }
    },
    [
      // product.id, site.id, unitOfOperation.id, dispatch
    ],
  );

  useEffect(() => {
    fetchData(false);
  }, [page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const onFolderClick = (folderId) => {
    setActiveFolder(folderId);
    setPage(1);
  };

  const changeChartType = (selectedChart) => {
    // navigate(`/analytics/visualization/charts/${selectedChart}`);
    navigate(`/analytics/visualization/charts`, {
      state: { chartType: selectedChart },
    });
  };

  const handleSearch = (flag) => {
    setPage(1);
    fetchData(flag);
  };

  const handleReset = () => {
    setVizName("");
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    fetchData(false);
  };

  // API-driven pagination count
  const totalPages = data?.total_pages || 1;

  return (
    <div>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        {/* <DropdownsBar /> */}
        <Grid container alignItems="center" spacing={0}>
          {/* Tabs */}
          <Grid item xs={12} md={12} sx={{ pr: { md: 0 } }}>
            <TabsBar />
          </Grid>

          {/* Filters + New Chart */}
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
              pl: { md: 0 },
              pr: 2,
              pb: 1,
            }}
          >
            {/* Filters Box */}
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                flexWrap: "wrap",
                mb: { xs: 1, md: 0 },
              }}
            >
              <TextField
                label="Visualization Name"
                variant="outlined"
                size="small"
                value={vizName}
                onChange={(e) => setVizName(e.target.value)}
                sx={{ width: 160 }}
              />
              <Box className="date-range-picker-visualization-dashboard">
                {[
                  ["startDate", "From"],
                  ["endDate", "To"],
                ].map(([key, placeholder]) => (
                  <DatePicker
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    popperClassName="custom-datepicker-popper"
                    key={key}
                    selected={key === "startDate" ? startDate : endDate}
                    onChange={(date) =>
                      key === "startDate"
                        ? setStartDate(date)
                        : setEndDate(date)
                    }
                    selectsStart={key === "startDate"}
                    selectsEnd={key === "endDate"}
                    startDate={startDate}
                    endDate={endDate}
                    minDate={
                      key === "endDate" && startDate ? startDate : undefined
                    }
                    maxDate={
                      key === "startDate" && endDate ? endDate : new Date()
                    }
                    placeholderText={placeholder}
                    dateFormat="dd-MMM-yyyy"
                    fixedHeight
                    renderCustomHeader={({
                      date,
                      decreaseMonth,
                      increaseMonth,
                      changeYear,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          px: 1.5,
                          py: 1,
                          bgcolor: "primary.main",
                          color: "common.white",
                          borderRadius: "8px 8px 0 0",
                        }}
                      >
                        <IconButton
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                          sx={{ color: "common.white", p: 0.5 }}
                          size="small"
                        >
                          <ArrowBackIosIcon fontSize="small" />
                        </IconButton>

                        <Box
                          sx={{
                            mx: 1,
                            fontWeight: 500,
                            cursor: "default",
                            width: 80,
                            textAlign: "center",
                          }}
                        >
                          <Label
                            text={date.toLocaleString("default", {
                              month: "long",
                            })}
                            color="#ffff"
                            fontSize={16}
                            fontWeight={600}
                          />
                        </Box>

                        <Select
                          value={date.getFullYear()}
                          onChange={(e) => changeYear(Number(e.target.value))}
                          size="small"
                          onMouseDown={(e) => e.stopPropagation()} // prevent closing
                          onClick={(e) => e.stopPropagation()} // prevent closing
                          sx={{
                            fontSize: 13,
                            color: "text.primary",
                            bgcolor: "background.paper",
                            borderRadius: 1,
                            // "& .MuiSelect-select": { py: 0.25, px: 1 },
                          }}
                        >
                          {Array.from(
                            { length: 50 },
                            (_, i) => new Date().getFullYear() - i,
                          ).map((y) => (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          ))}
                        </Select>

                        <IconButton
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                          sx={{ color: "common.white", p: 0.5 }}
                          size="small"
                        >
                          <ArrowForwardIosIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                    customInput={
                      <TextField
                        size="small"
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CalendarTodayIcon fontSize="small" />
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    }
                  />
                ))}
              </Box>

              <FormControl size="small" sx={{ width: 100 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={statusFilter}
                  label="Status"
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="favourite">Favourite</MenuItem>
                  <MenuItem value="template">Template</MenuItem>
                </Select>
              </FormControl>

              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSearch(true)}
                sx={{ textTransform: "none", minWidth: 80 }}
              >
                <Label text="Search" color="inherit" />
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                sx={{ textTransform: "none", minWidth: 80 }}
              >
                <Label text="Reset" color="inherit" />
              </Button>
            </Box>

            {/* New Chart Button */}
            <Button
              variant="contained"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              sx={{
                textTransform: "none",
                minWidth: 150,
                backgroundColor: "#3882DB",
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "&:hover": { backgroundColor: "#2f6fb8" },
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <AddIcon />
                {/* <Label text={selectedChart} color="inherit" /> */}
                <Label text="New Chart" color="inherit" />
              </Box>
              {/* <ArrowDropDownIcon /> */}
            </Button>

            {/* Chart Dropdown Menu */}
            <Menu
              anchorEl={anchorEl}
              open={openChartMenu}
              onClose={() => setAnchorEl(null)}
              PaperProps={{
                sx: {
                  backgroundColor: "#3882DB",
                  color: "#fff",
                  mt: 1,
                  minWidth: 140,
                },
              }}
            >
              {plotTypeOptions.map((chart) => (
                <MenuItem
                  key={chart.value}
                  onClick={() => {
                    setAnchorEl(null);
                    changeChartType(chart.value);
                  }}
                  sx={{
                    color: "#fff",
                    "&:hover": { backgroundColor: "#2f6fb8" },
                  }}
                >
                  {/* <AddIcon fontSize="small" /> */}
                  <Label text={chart.label} color="inherit" />
                </MenuItem>
              ))}
            </Menu>
          </Grid>
        </Grid>

        <Divider sx={{ mx: 2 }} />
        <Box sx={{ py: 0.5 }}>
          <BreadcrumbsBar />
        </Box>
        <Divider sx={{ mx: 2 }} />

        <Box
          className="visualization-container"
          sx={{ height: "calc(100vh - 180px)" }}
        >
          {/* {loader ? (
            <Box py={6} display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : ( */}
          <Grid container className="grid-container">
            <Grid item xs={12} className="viz-list-main-panel">
              <Box className="viz-list-main-wrapper">
                <Box className="viz-list-table-wrapper">
                  <ParameterTable reposrtsList={reposrtsList} />
                </Box>

                <Box className="viz-list-pagination">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
          {/* {loader && <Loader />} */}
          {/* )} */}
        </Box>
      </InvestigatorContainer>

      {/* Snackbar Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.text}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Index;
